import MdxPage from '@/components/mdx-page'
import Privacy from './privacy.mdx'

const PrivacyView = () => {
  return (
    <div className="container-sm pb-20 md:pb-30">
      <h2 className="py-8 text-center md:py-20">プライバシーポリシー</h2>
      <div className="bg-glass break-words px-4 py-8 md:px-6 md:pt-10 md:pb-16">
        <MdxPage>
          <Privacy />
        </MdxPage>
      </div>
    </div>
  )
}

export default PrivacyView
